// Arrow components
const ArrowDown = ({ 
  size = 24,
  color = "#1C2A46",
  strokeWidth = 1.5,
  className = "",
  ...props 
}) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path 
        d="M19.92 8.9502L13.4 15.4702C12.63 16.2402 11.37 16.2402 10.6 15.4702L4.07996 8.9502" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeMiterlimit="10" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ArrowUp = ({ 
  size = 18,
  color = "#1C2A46",
  strokeWidth = 1.5,
  className = "",
  ...props 
}) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 18 9" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path 
        d="M16.59 7.8475L10.07 1.3275C9.3 0.5575 8.04 0.5575 7.27 1.3275L0.75 7.8475" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeMiterlimit="10" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { 
  ArrowDown,
  ArrowUp
};